module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 112.18 117.97\"><title></title><rect x=\"4\" y=\"28.26\" width=\"85.71\" height=\"85.71\" style=\"fill:#fff;stroke:#edaa24;stroke-miterlimit:10;stroke-width:6px\"></rect></svg>"


//////////////////
// WEBPACK FOOTER
// ./home/en-US/images/svg/checkbox_off.svg
// module id = FTf6
// module chunks = 0